import { Component } from '@angular/core';
import { select } from '@ngrx/store';
import {ContainerFormMapBaseComponent} from 'src/app/shared';
import {ZonaExclusion} from "../../../../../chacra-core/models/zonas-exclusion";
import {selectZonaExclusionById} from "../../../../store/entities/shared/zonas-exclusion/zonas-exclusion.selectors";

@Component({
    selector: 'app-zonas-exclusion-form',
    templateUrl: './zonas-exclusion-form.component.html',
    styleUrls: ['./zonas-exclusion-form.component.scss']
})
export class ZonasExclusionFormComponent extends ContainerFormMapBaseComponent {

    _item: ZonaExclusion;

    form = this.fb.group({
        zonaExclusionId: [null],
    });

    ngOnInit(): void {        
        this.subscriptions.push(
            this.store.pipe(select(selectZonaExclusionById(this.item.zonaExclusionId)))
                .subscribe(item => {
                    if (item) {
                        this.item = item;
                    }
                })
        );
    }

    setItem() {
        this.form.patchValue({
            zonaExclusionId: this.item.zonaExclusionId,
        });
    }

    getTitle(): string {
        let title = 'Parche de elevación: ';
        if (this.item) {
            title += this.item.zonaExclusionId;
        }
        return `${title}${super.getTitle()}`;
    }

    getValues() {        
        const value: ZonaExclusion = {
            ...this.item,
            ...this.form.value,
        };
        return { ...value };
    }
}
